import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Perfil, Sistema } from '../models/perfil';
import { GlobalService } from './global.service';
import { Tela } from './../models/perfil';
import { Relatorio } from '../models/relatorios';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarPerfis() {
    return this.http.get<Perfil[]>(globals.apiUrl + '/api/Perfil/Lista');
  }

  consultarPerfisComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Perfil/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdPerfil(idPerfil) {
    return this.http.get<any>(globals.apiUrl + '/api/Perfil/Buscar',
      { params: new HttpParams().set('id', idPerfil) });
  }

  salvar(perfil: Perfil) {
    return this.http.post(globals.apiUrl + '/api/Perfil/Salvar', perfil);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Perfil/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarTelas() {
    return this.http.get<Tela[]>(globals.apiUrl + '/api/Perfil/BuscarTelas');
  }

  consultarRelatorios() {
    return this.http.get<Relatorio[]>(globals.apiUrl + '/api/Perfil/BuscarRelatorios');
  }

  consultarTelasDosPerfis(ids: Number[]) {
    return this.http.post(globals.apiUrl + '/api/Perfil/BuscarTelasDosPerfis', { ids });
  }

  consultarRelatoriosDosPerfis(ids: Number[]) {
    return this.http.post(globals.apiUrl + '/api/Perfil/BuscarRelatoriosDosPerfis', { ids });
  }
}
